// src/App.js
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Login from './components/Auth/Login';
import Gateways from './components/Gateways/Gateways';
// import Layout from './components/Layout/Layout';
import GatewayDetails from './components/Gateways/GatewayDetails/GatewayDetails';
import GenericReadoutSchedule from './components/Gateways/Readouts/GenericReadoutSchedule';
import FwdProfiles from './components/Fwds/FwdProfiles';
import EditFwdProfile from './components/Fwds/EditFwdProfile';
import FwdAssignments from './components/Fwds/FwdAssignments';
import CreateFwdAssignment from './components/Fwds/CreateFwdAssignment';
import Locations from './components/Locations/Locations';
import LocationDetails from './components/Locations/LocationDetails';
import CreateLocation from './components/Locations/CreateLocation';
import EditLocation from './components/Locations/EditLocation';
import Networks from './components/Networks/Networks';
import NetworkScheduleScan from './components/Networks/NetworkScheduleScan';
import MeterScheduleScan from './components/Meters/MeterScheduleScan';
import ManageMetersList from './components/Meters/ManageMetersList';
import NetworkDetails from './components/Networks/Details/NetworkDetails';
import ChangeNetworkMode from './components/Networks/ChangeNetworkMode';
import AllGateways from './components/debug/allGw';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import Settings from './components/Settings/Settings'; 
import Maintenance from './components/Maintanance';
import { AuthProvider } from './contexts/AuthProvider';
import { NotificationProvider } from './contexts/NotificationContext';
import { Create } from '@mui/icons-material';

const App = () => {

  const [maintenanceMode, setMaintenanceMode] = useState(false);

  useEffect(() => {
      const checkMaintenanceMode = async () => {
          try {
		          const baseURL = process.env.REACT_APP_API_URL || '';
              const response = await axios.get(`${baseURL}/api/auth/maintenance`);
              setMaintenanceMode(response.data.maintenance);
          } catch (error) {
              console.error('Error checking maintenance mode:', error);
              setMaintenanceMode("Errore");
          }
      };

      checkMaintenanceMode();
  }, []);

  return ( 
      <AuthProvider>
        <NotificationProvider>
          <Router>
            <ErrorBoundary>
              <Routes>
                {maintenanceMode ? (
                      <Route path="*" element={<Maintenance />} />
                  ) : (
                      <>
                      <Route path="/" element={<Login />} />
                      <Route path="/gateways" element={<ProtectedRoute element={Gateways}/>} /> 
                      <Route path="/gateways/:gatewayId" element={<ProtectedRoute element={GatewayDetails}/>} /> 
                      <Route path="/gateways/:gatewayId/scan/networks" element={<ProtectedRoute element={NetworkScheduleScan}/>} /> 
                      <Route path="/gateways/:gatewayId/scan/meters" element={<ProtectedRoute element={MeterScheduleScan}/>} /> 
                      <Route path="/gateways/:gatewayId/readouts" element={<ProtectedRoute element={GenericReadoutSchedule}/>} /> 
                      <Route path="/gateways/:gatewayId/meters" element={<ProtectedRoute element={ManageMetersList}/>} /> 
                      {/* <Route path="/gateways/:gatewayId/scan/meters" element={<ProtectedRoute element={GatewayDetails}/>} />  */}
                      <Route path="/locations" element={<ProtectedRoute element={Locations}/>} /> 
                      <Route path="/locations/:locationId" element={<ProtectedRoute element={LocationDetails}/>} /> 
                      <Route path="/locations/create" element={<ProtectedRoute element={CreateLocation}/>} />
                      <Route path="/locations/edit/:locationId" element={<ProtectedRoute element={EditLocation}/>} />
                      <Route path="/profiles" element={<ProtectedRoute element={FwdProfiles}/>} /> 
                      <Route path="/profiles/:profileId" element={<ProtectedRoute element={EditFwdProfile}/>} /> 
                      <Route path="/profiles/create" element={<ProtectedRoute element={EditFwdProfile}/>} /> 
                      <Route path="/assignments" element={<ProtectedRoute element={FwdAssignments}/>} /> 
                      <Route path="/assignments/create" element={<ProtectedRoute element={CreateFwdAssignment}/>} /> 
                      <Route path="/networks" element={<ProtectedRoute element={Networks}/>} /> 
                      <Route path="/networks/:networkId" element={<ProtectedRoute element={NetworkDetails}/>} /> 
                      <Route path="/networks/:networkId/change-mode" element={<ProtectedRoute element={ChangeNetworkMode}/>} /> 
                      <Route path="/allgateways" element={<ProtectedRoute element={AllGateways}/>} /> 
                      <Route path="/settings" element={<ProtectedRoute element={Settings}/>} />
                      </>
                  )}
              </Routes>
            </ErrorBoundary>
          </Router>
        </NotificationProvider>
      </AuthProvider>
  );
};

export default App;
